export {
    MENU_SURFACES,
    MENU_ITEMS,
    MENU_CATEGORIES,
    MENU_ITEMS_BY_ID,
    getMenuItem,
    getMenuLabel,
} from './menuManifest'

export {
    createMenuVisibilityContext,
    filterVisibleMenuItems,
    getVisibleMenuKeys,
    isMenuItemVisible,
} from './menuVisibility'

export {
    USER_TOP_NAV_SECTIONS,
    OPERATOR_USER_MENU_SECTIONS,
    OPERATOR_SUBSCRIPTIONS_SECTION,
    OPERATOR_DATA_SECTION,
    OPERATOR_OPS_GROUPS,
} from './shellMenuLayout'

export { MENU_ICON_REGISTRY, getMenuIconDef, getMenuLucideIcon } from './menuIcons'

export const FAVORITES_STORAGE_KEY = 'sgez.menuFavorites.v1'

export function loadFavorites() {
    try {
        const raw = window?.localStorage?.getItem(FAVORITES_STORAGE_KEY)
        const arr = raw ? JSON.parse(raw) : []
        return new Set(Array.isArray(arr) ? arr : [])
    } catch {
        return new Set()
    }
}

export function saveFavorites(favorites) {
    try {
        window?.localStorage?.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(Array.from(favorites)))
    } catch {
        // ignore
    }
}
